var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 1C14.7127 1 18.7422 5.02945 18.7422 10C18.7422 11.7813 18.2246 13.4417 17.3317 14.8391L18.7422 19L14.5813 17.5895C13.1838 18.4824 11.5235 19 9.74219 19C4.77163 19 0.742188 14.9706 0.742188 10C0.742188 5.02945 4.77163 1 9.74219 1Z",
    stroke: "#B9B0BB",
    strokeWidth: 1.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 5.57648V11.373",
    stroke: "#B9B0BB",
    strokeWidth: 1.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 13.9654L9.74219 13.9082",
    stroke: "#B9B0BB",
    strokeWidth: 1.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.fe03efecdf8b0b3f8d90bebdf441bb9d.svg";
export { ForwardRef as ReactComponent };